// 🔒 The cover that sits over a locked photo, video or album.
//
// Deliberately OPAQUE, never blurred: a blur of the real image is still the real
// image. Faces, skin tone, a document's layout and the general "what is this"
// all survive it, and the person sitting beside you is exactly who a blur fails
// against. Nothing shows through, so there is nothing to squint at.
//
// It renders as an absolute fill, so it drops INSIDE whatever clipped box the
// media already lives in and inherits its exact size and corners — no dimension
// maths, no layout shift when it goes away.
//
// 🟥 NO BIOMETRIC PROMPT. The phone has Face ID and a fingerprint reader; a
//    desktop, in practice, has neither — so the gate here is the deliberate
//    action itself: click a cover to reveal that one item, or flick "Reveal
//    media" in Chat info to uncover the chat while you're looking at it. That
//    is what the feature is actually for — the person beside you can't read
//    what isn't drawn, and nothing uncovers by accident.

import React, { useEffect, useState } from 'react';
import { Lock } from './icons';
import { unlockMessage, subscribe, isCovered } from '../services/privateMedia';

/** Subscribe one bubble to "is my media covered right now". */
export function useCovered(chatId, messageId) {
  const [v, setV] = useState(() => isCovered(chatId, messageId));
  useEffect(() => {
    const read = () => setV(isCovered(chatId, messageId));
    read();
    return subscribe(read);
  }, [chatId, messageId]);
  return v;
}

export default function PrivateCover({ messageId, label = 'Click to reveal', small, readOnly }) {
  return (
    <button
      className={`pm-cover ${small ? 'sm' : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        if (readOnly) return;
        unlockMessage(messageId);
      }}
      title={readOnly ? 'Covered — reveal it in the chat' : label}
    >
      <span className="pm-dots"><i /><i /><i /></span>
      <span className="pm-lock"><Lock width={small ? 13 : 17} height={small ? 13 : 17} /></span>
      {!small && <span className="pm-label">{label}</span>}
    </button>
  );
}
